// extracted by mini-css-extract-plugin
export default {"summary-container":"DoctorReportSummary_summary-container__YKEm5","summary-ctas":"DoctorReportSummary_summary-ctas__TDDkD"};